module.exports = __webpack_public_path__ + "img/daily-sales.6dd459e4.svg";